import { render, staticRenderFns } from "./TopoguideView.vue?vue&type=template&id=20c881e8&scoped=true"
import script from "./TopoguideView.vue?vue&type=script&lang=js"
export * from "./TopoguideView.vue?vue&type=script&lang=js"
import style0 from "./TopoguideView.vue?vue&type=style&index=0&id=20c881e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c881e8",
  null
  
)

export default component.exports